import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild
} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {CommonModule, formatDate} from '@angular/common';
import {ApplicationFormDirective} from './application-form.directive';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {DynamicStepComponent} from '../dynamic-step/dynamic-step.component';
import {SubmitEvent} from '../../model/events';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {FieldData, StepResource} from '../../core/modules/openapi';
import {CompletedStep} from "../../model/step";

@Component({
  selector: 'app-application-form',
  imports: [CommonModule, MatStepperModule, DynamicStepComponent],
  templateUrl: './application-form.component.html',
  standalone: true,
  styleUrl: './application-form.component.sass'
})
export class ApplicationFormComponent implements OnInit {
  @Input() steps: string[];
  @Input() step: StepResource;
  @Output() onStepCompleted = new EventEmitter<CompletedStep>();
  @Output() onStepChanged = new EventEmitter<number>();
  @ViewChild(ApplicationFormDirective, {static: true}) container: ApplicationFormDirective;
  @ViewChild(MatStepper, {static: true}) stepper: MatStepper;

  components: ComponentRef<any>[] = [];
  form: FormGroup;
  stepError: boolean = false;
  showResult: boolean = false;

  ngOnInit(): void {
    this.form = new FormGroup({});
  }

  addComponent(componentClass: Type<any>) {
    // Create component dynamically inside the ng-template
    const component = this.container.viewContainerRef.createComponent(componentClass);

    // Push the component so that we can keep track of which components are created
    this.components.push(component);
    return component;
  }

  validateAllFormFields(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: AbstractControl<any>) => {
      control.markAsTouched();

      if (control instanceof FormGroup && control.controls) {
        this.validateAllFormFields(control);
      }
    });
  }

  public moveToDone(event: any, sequence: number) {
    //this.alertService.clear();
    if (event instanceof SubmitEvent) {
      let completedStep: CompletedStep;
      let completedFields: FieldData[] = [];
      Object.entries(event.data).forEach(([key, value]) => {
        let field = this.step.fields.filter(f => f.name === key)[0];
        if (field) {
          if (field.type === 'date') {
            completedFields.push({
              name: key,
              value: formatDate(value as string, 'yyyy-MM-dd', 'en-US')
            });
          } else {
            completedFields.push({name: key, value: value as string});
          }
        }
      });
      if (event.source === 'next') {
        this.onStepCompleted.emit({
          completedIndex: sequence,
          nextIndex: sequence + 1,
          stepData: {
            sequence: sequence,
            fields: completedFields,
            isSubmitted: false
          }
        });
        if (sequence + 1 < this.steps.length) {
          this.stepper.next();
        }
      } else if (event.source === 'back') {
        this.onStepCompleted.emit({
          completedIndex: sequence,
          nextIndex: sequence - 1,
          stepData: {
            sequence: sequence,
            fields: completedFields,
            isSubmitted: false
          }
        });
        this.stepper.previous();
      } else if (event.source === 'submit') {
        this.onStepCompleted.emit({
          completedIndex: sequence,
          nextIndex: sequence + 1,
          stepData: {
            sequence: sequence,
            fields: completedFields,
            isSubmitted: true
          }
        });
      }
    }
    this.stepError = false;
  }

  stepChanged(event: StepperSelectionEvent) {
    this.onStepCompleted.emit({
      completedIndex: event.previouslySelectedIndex,
      nextIndex: event.selectedIndex
    });
  }
}
